<template class="overflow-y-hidden">
  <!-- page meta -->
  <div>
    <Head>
      <title>Platforma | Monetize Everyone</title>
      <link
        rel="icon"
        :href="$filters.public_path('favicon.png')"
        type="favicon"
      />
      <meta
        name="description"
        content="Create a private membership site platform to monetize your content."
      />
    </Head>
  </div>
  <!-- content start -->
  <div
    class="min-[1140px]:max-w-[1140px] container relative mx-auto bg-transparent"
  >
    <!-- hero section -->
    <section
      id="section1"
      class="section1 hero-section relative mx-auto mt-[150px] justify-center gap-1 bg-transparent lg:flex lg:py-0"
      :style="backgroundImageStyleMain"
    >
      <!-- heading & form -->
      <div class="mt-0 bg-transparent px-[25px] xl:px-0 lg:w-[440px] z-10">
        <h1
          class="top-full w-full mt-0 px-0 text-[35px] font-extrabold tracking-normal text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
        >
          One login to monetize audiences.
        </h1>
        <p
          class="mt-[5px] mb-[25px] text-[15px] font-normal text-[#7c828d] lg:text-lg"
        >
          All your content in one place: Courses, Coaching, Podcasts & More.
        </p>
        <EmailCaptureHeader />
        <!-- reviews -->
        <img :src="$filters.media_path('/images/stars.svg')" alt="" />
      </div>
      <!-- video -->
      <div class="scroll-to-top mb-[30px] mt-[30px] lg:mt-0 z-10 w-full">
        <video
          class="home-hero-video xl:absolute xl:w-[900px] xl:translate-x-[12%] xl:-translate-y-[5%] aspect-auto"
          id="home_video"
          loop
          muted
          autoplay
          playsinline
        >
          <source
            :src="$filters.media_path('/videos/home_video.webm')"
            type="video/webm"
          />
        </video>
      </div>
    </section>
    <!-- tag -->
    <div
      class="join-mobile mx-auto mt-[30px] h-[150px] max-w-6xl gap-2 bg-[#f5f8fa] py-[65px] md:mt-[50px] md:flex md:h-auto md:bg-[#fafbfc] md:bg-blend-overlay"
    >
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
      <h2
        class="mx-auto px-0 text-center text-[12px] font-[500] text-[#7c828d]"
      >
        JOIN 10,000+ HIGH EARNING BUSINESSES & CREATORS
      </h2>
      <div class="m-auto hidden h-[1px] w-[400px] bg-[#e9ebf0] md:flex"></div>
    </div>
  </div>
  <!-- course/chat/community -->
  <HomeTabOne />
  <!-- member/stream/video -->
  <HomeTabTwo />
  <!-- platform green -->
  <HomeTabThree />
  <!-- built for everyone yellow -->
  <HomeTabFour />
  <!-- support section -->
  <!-- v-for="(header, index) in headers" -->
  <!-- :key="header" -->
  <section
    id="support"
    class="support-section lg:w-[1040px] mx-[25px] lg:mx-auto lg:flex mt-[50px]"
  >
    <div>
      <img
        loading="lazy"
        class=""
        :src="$filters.media_path('/images/24-chat-icon-blue.svg')"
        alt="24/7 support"
      />
      <div
        ref="el"
        id="text_interface"
        class="text-xs font-bold tracking-wide text-[#292d34] mt-[50px]"
      >
        #1 SUPPORT IN SOFTWARE
      </div>
      <!-- :id="index" -->
      <h2
        id="index"
        class="top-full mt-[25px] text-[35px] font-bold text-[#292d34] sm:text-[40px] lg:text-[45px] lg:leading-[69px] xl:text-[50px]"
      >
        <!-- {{ header }} -->
        24/7 real-time support.
      </h2>
      <p
        class="mt-[40px] mb-10 text-sm font-normal leading-[25px] text-[#292d34] xl:max-w-[440px]"
      >
        Platforma has the highest rated client support in software. We're here
        24 hours a day, every day of the week, including holidays.
      </p>

      <div class="md:flex">
        <div class="flex pr-5">
          <!-- {{ currentSection }} -->
          <img
            loading="lazy"
            class="pr-[5px]"
            :src="$filters.media_path('/images/blue-checkmark-circle-icon.svg')"
            alt="Podcast episode list"
          />
          <p class="text-sm font-normal my-auto">Free Coaching</p>
        </div>
        <div class="flex pr-5 mt-[20px] md:mt-0">
          <img
            loading="lazy"
            class="pr-[5px]"
            :src="$filters.media_path('/images/blue-checkmark-circle-icon.svg')"
            alt="Podcast episode list"
          />
          <p class="text-sm font-normal my-auto">Webinars</p>
        </div>
        <div class="flex pr-5 mt-[20px] md:mt-0">
          <img
            loading="lazy"
            class="pr-[5px]"
            :src="$filters.media_path('/images/blue-checkmark-circle-icon.svg')"
            alt="Podcast episode list"
          />
          <p class="text-sm font-normal my-auto">Chat & Phone</p>
        </div>
      </div>
    </div>
    <div class="mt-[30px] lg:mt-0">
      <img
        loading="lazy"
        class="lg:w-[650px]"
        :src="
          $filters.media_path(
            '/images/online-course-support-help-building-online-course-platform.png'
          )
        "
        alt="24/7 Online Course Building"
      />
    </div>
  </section>
  <!-- cta block -->
  <ProtectCtaBlock />
</template>

<script>
import DefaultLayout from '../Layouts/DefaultLayout.vue';
export default {
  layout: DefaultLayout
};
</script>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import ButtonComponent from '@shared/Components/ButtonComponent.vue';
import EmailCaptureHeader from '../Components/EmailCaptureHeader.vue';
import EmailIntegrationsSlider from '../Components/EmailIntegrationsSlider.vue';
import HomeTabOne from '../Components/HomeTabOne.vue';
import HomeTabTwo from '../Components/HomeTabTwo.vue';
import HomeTabThree from '../Components/HomeTabThree.vue';
import HomeTabFour from '../Components/HomeTabFour.vue';
import ProtectCtaBlock from '../Components/ProtectCtaBlockFooter.vue';
import Axios from 'axios';

const openTab = ref(1);

const toggleTabs = (tabNumber) => {
  openTab.value = tabNumber;
};

const backgroundImageStyleMain = computed(() => {
  const imagePath =
    '../../../../media/images/platforma-header-background-eclipse.svg';
  return {
    '--before-background-image': `url(${imagePath})`
  };
});
</script>

<style scoped>
.hero-section::before {
  content: '';
  position: absolute;
  top: 0;
  height: 1000px;
  width: 1700px;
  display: block;
  z-index: 0;
  transform: translateY(-42%) translateX(58%);
  background-repeat: no-repeat;
  background-image: var(--before-background-image);
}

.join-mobile {
  background-image: url(../media/images/two-dots.svg);
  background-size: contain;
}

.support-section {
  background-image: url(../media/images/dots-shape.svg);
  background-position: right;
  background-repeat: no-repeat;
}
</style>
